import { useTranslation } from 'react-i18next';

export default function BottomCTA() {
  const { t } = useTranslation('products');

  return (
    <section className="w-full bg-cream-100 border-t border-ink-100">
      <div className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
        <div className="max-w-2xl mx-auto text-center">
          <h3 className="text-lg md:text-xl font-bold text-ink-700 mb-2">
            {t('products.bottomCTA.title')}
          </h3>
          <p className="text-sm text-ink-400 mb-6">
            {t('products.bottomCTA.text')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="/image-search"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 border border-ink-300 rounded-lg text-sm font-medium text-ink-600 hover:bg-white transition-colors"
            >
              <i className="ri-image-line text-base" />
              {t('products.bottomCTA.imageSearch')}
            </a>
            <a
              href="/quote"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-ink-700 text-white rounded-lg text-sm font-medium hover:bg-ink-600 transition-colors"
            >
              <i className="ri-file-list-3-line text-base" />
              {t('products.bottomCTA.requestQuote')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}